import React from 'react';
import ReactDOM from 'react-dom';

import { 
    SmileReaction,
    HeartReaction,
    ThumbsUpReaction
} from '../../components/Video/Reactions';
import { VideoService } from '../VideoService';

const timeoutDelay = 700;

const getVideoPlayerRef = () => document.querySelector('.video-js video.vjs-tech');

const buildContainer = () => {
    let container = document.createElement('div');
    container.className = 'video-reactions-container';
    return container;
};

const getContainer = () => {
    const ref     = getVideoPlayerRef();
    let container = null;
    if (ref) {
        container = buildContainer();
        ref.after(container);
    }
    return container;
}

const removeEmoji = (container) => {
    // Empty emoji container
    if (container) {
        ReactDOM.unmountComponentAtNode(container);
        container.parentNode.removeChild(container);
    }
};

const addEmoji = (emoji) => { 
    const container = getContainer();

    if (!container) return;

    // Insert emoji over video
    ReactDOM.render(emoji, container);
    // Remove emoji (after a delay)
    setTimeout(() => removeEmoji(container), timeoutDelay);
};

export const VideoReactionsService = {
    
    smile: (params) => {
        if (VideoService.checkFragmentId(params.fragmentId)) {
            addEmoji(<SmileReaction />);
        }
    },

    heart: (params) => {
        if (VideoService.checkFragmentId(params.fragmentId)) {
            addEmoji(<HeartReaction />);
        }
    },

    thumbsUp: (params) => {
        if (VideoService.checkFragmentId(params.fragmentId)) {
            addEmoji(<ThumbsUpReaction />);
        }
    },

    destroy: () => {
        // Is there any tidy up required?
    }

}

export default VideoReactionsService;